"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchEthAssetDetails = void 0;
var request_1 = __importDefault(require("../../tools/request"));
var utils_1 = require("../../tools/utils");
var query_1 = __importDefault(require("../../tools/query"));
function fetchEthAssetDetails(base, ethAssetId) {
    var id = utils_1.toArray(ethAssetId);
    return request_1.default({ base: base, url: "/eth/assets?" + query_1.default({ id: id }) }).then(function (list) { return Array.isArray(ethAssetId) ? list : list[0]; });
}
exports.fetchEthAssetDetails = fetchEthAssetDetails;
//# sourceMappingURL=index.js.map